export function DetailRow({
  icon: Icon,
  label,
  value,
  mono,
}: {
  icon: React.ElementType;
  label: string;
  value: string;
  mono?: boolean;
}) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-50">
          <Icon className="h-4 w-4 text-slate-400" />
        </div>
        <span className="text-sm text-slate-500">{label}</span>
      </div>
      <span
        className={`text-sm font-medium text-slate-900 ${mono ? 'font-mono' : ''}`}
      >
        {value}
      </span>
    </div>
  );
}
